<template>
    <div class="wrapper flex flex-column justify-content-center align-items-center p-4  w-full h-full">
        <CustomBreadcrumb class="flex align-self-start"
            :items="[{ label: 'Profile Settings' }, { label: 'Security' }]" />
        <span class="H6-Medium block text-center mt-6">Make sure your account is remain safe</span>
        <div class="md:col-11 md:p-5 mt-4">
            <div class="w-full col-12 grid ">
                <ChangeEmail :profile="profile" />
                <Divider />
                <ChangePasswordV2 :profile="profile" />
                <Divider />
                <TwoStepToggle :profile="profile" />
            </div>
        </div>
    </div>
</template>

<script setup>
import CustomBreadcrumb from '@/components/CustomBreadcrumb.vue';
import { Divider } from "primevue";
import { defineProps } from 'vue';
import ChangeEmail from '../ChangeEmail.vue';
import ChangePasswordV2 from '../changePasswordV2.vue';
import TwoStepToggle from '../twoStepToggle.vue';

defineProps({
    profile: {
        type: Object,
        required: true
    }
});
</script>
<style scoped>
/* .wrapper {
    height: 95%;
    background-color: white;
    border-radius: 10px;
    box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
} */
</style>